<template>
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title">{{ $t("CampaignEdit.Cost.TabsGrid.Columns.Tag") }} {{ campaignTag.Tag }}</p>
      <button
          type="button"
          class="delete"
          @click="close()"/>
    </header>
    <section class="modal-card-body">
      <b-field :label="$t('CampaignEdit.Cost.TabsGrid.Columns.Cost')">
        <b-input type="number" v-model="campaignTag.Cost"
                 :placeholder="$t('CampaignEdit.Cost.TabsGrid.Columns.Cost')"></b-input>
      </b-field>
    </section>
    <footer class="modal-card-foot">
      <b-button :label="$t('OK')" type="is-primary" @click="update()"/>
    </footer>
  </div>
</template>

<script lang="ts">
import {Component, Prop, Vue} from "vue-property-decorator";
import {CampaignTag} from "@/models/campaigns/CampaignTag";

@Component({})
export default class CampaignTagEdit extends Vue {
  @Prop() readonly campaignTag!: CampaignTag;

  close() {
    this.$emit("close");
  }

  update() {
    this.$emit("update", this.campaignTag);
    this.$emit("close");
  }
}
</script>
